/** @jsx jsx */
import React from "react";
import { graphql } from "gatsby";
import { jsx, Container } from "theme-ui";
import ContentfulRichText from "../../shared/ContentfulRichText";

export const query = graphql`
  fragment ContentfulRichTextSectionFragment on ContentfulRichTextSection {
    h4HeadingColor
    content {
      raw
      references {
        __typename
        ...ContentfulWistiaItemFragment
      }
    }
  }
`;

const RichTextSection = ({ sectionContent }) => {
  const { content, h4HeadingColor } = sectionContent;

  return (
    <Container>
      <ContentfulRichText richText={content} h4HeadingColor={h4HeadingColor} />
    </Container>
  );
};

export default RichTextSection;
